import React from 'react'

import { Props } from './types'

import {
  Container,
  Image,
  Label,
  Radio,
} from './styles'

const InsuranceTypeRadio: React.FC<Props> = ({
  children,
  insuranceType,
  isChecked,
  name,
  onClick,
  value,
}): React.ReactElement => (
  <Container
    htmlFor={name}
    onClick={onClick}
  >
    <Radio isChecked={isChecked} />
    {(insuranceType !== 'other' && [
      <Image
        key='bw'
        insuranceType={insuranceType}
        isActive={!isChecked}
        isColor={false}
      />,
      <Image
        key='color'
        insuranceType={insuranceType}
        isActive={isChecked}
        isColor={true}
      />,
    ]) ||
      undefined}
    <Label insuranceType={insuranceType}>
      {children || value}
    </Label>
  </Container>
)

export * from './types'

export default InsuranceTypeRadio
